import { get, isMockMode, simulateDelay } from "../../api";

export const getFeatures = ({ productId }) => {
	if (isMockMode()) {
		const testData = [
			{
				id: 0,
				code: "string",
				name: "string",
				description: "string",
				defaultValue: true,
			},
		];

		return simulateDelay(50, () => testData);
	}

	return get(`products/getFeatures?productId=${productId}`);
};
